import React from "react";
import { useTranslation } from "react-i18next";
import {
  AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer
} from "recharts";

function SLAChartTrend({ data }) {
  const { t } = useTranslation();
  const items = Array.isArray(data) ? data : [];

  if (!items.length) {
    return (
      <div className="p-3 bg-white rounded-4 shadow-sm">
        {t("sla.chart.no_trend", "No trend data")}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-4 shadow-sm p-4" style={{ height: 350 }}>
      <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>
        {t("sla.charts.trend", "SLA Trend")}
      </div>

      <ResponsiveContainer>
        <AreaChart data={items}>
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Area dataKey="on_time" name={t("sla.chart.on_time", "On Time")} fill="#4CAF50" />
          <Area dataKey="breached" name={t("sla.chart.breached", "Breached")} fill="#F44336" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SLAChartTrend;
